var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sentence",class:[
    ("text-" + _vm.textSize),
    ("text-width-" + _vm.textWidth),
    _vm.selected.word !== null ? 'highlighting' : null ]},[_vm._l((_vm.words),function(word){return [_c('Word',{key:word.id,attrs:{"word":word,"selected":_vm.selected},on:{"word-enter":_vm.onWordEnter,"word-leave":_vm.onWordLeave}}),_vm._v(" "+_vm._s(' ')+" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }